import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { DxTreeViewComponent } from 'devextreme-angular';
import { AppEventService, DataCacheService } from 'pumpcalc-core';

@Component({
  selector: 'app-pumpset-selection-list',
  templateUrl: './pumpset-selection-list.component.html',
  styleUrls: ['./pumpset-selection-list.component.css']
})
export class PumpsetSelectionListComponent implements OnInit, OnChanges {

  @ViewChild("tree") tree:DxTreeViewComponent;  
  @Input() context;
  @Input() parameters;
  lastSelected;  
  show=false;
  selectEnabled=false;
  list:any[]=[];    

  constructor(private appEventService:AppEventService, private dataCacheService:DataCacheService) {

  }

  ngOnChanges(changes: SimpleChanges): void {        
    this.list = this.dataCacheService.get(this.context);    
    this.show=true;
    this.selectEnabled=false;    
  }

  ngOnInit(): void {
  }
  
  selectItem(event){
    if(event.itemData.name){
      this.lastSelected=event.itemData;
      this.selectEnabled=true;            
    }
  }

  select(){
     this.appEventService.emit({name:"SELECTION",context:this.context,data:this.lastSelected,parameters:this.parameters});
     this.show=false;
  }

  cancel(){
     this.show=false;
  }

  showPumpSetInDiagram($event){
    this.appEventService.emit({name:"VIEW",context:this.context,data:$event,parameters:this.parameters});
  }
  

}
